import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import hackerRankImage from '../../../assets/images/HackerRank Image.jpeg';

const certificates = [
  {
    title: 'Software Engineer',
    issuedBy: 'HackerRank',
    date: '25 December 2025',
    image: hackerRankImage,
    link: 'https://drive.google.com/file/d/1nURuPSTJ633BheDO29q4mBFcaBL0TI0W/view?usp=sharing'
  },
  {
    title: 'Java (Basic)',
    issuedBy: 'HackerRank',
    date: '11 August 2025',
    image: hackerRankImage,
    link: 'https://drive.google.com/file/d/1SrOa3FPoE7QDYG0d08dR01QFO2pZknWv/view?usp=drive_link'
  },
  {
    title: 'SQL (Basic)',
    issuedBy: 'HackerRank',
    date: '19 December 2024',
    image: hackerRankImage,
    link: 'https://drive.google.com/file/d/1FJVm2CSTIIRTjgW0rKT0z4fDyhYnjT-z/view?usp=drive_link'
  },
  {
    title: 'SQL (Intermediate)',
    issuedBy: 'HackerRank',
    date: '6 September 2025',
    image: hackerRankImage,
    link: 'https://drive.google.com/file/d/1WH6xbhFRn0KS3-N8Jswcc3umsq2cThoR/view?usp=sharing'
  },
  {
    title: 'CSS (Basic)',
    issuedBy: 'HackerRank',
    date: '19 December 2024',
    image: hackerRankImage,
    link: 'https://drive.google.com/file/d/1Q9Wbxc7RYJqfDb9p8EBfFO06vOGvWTje/view?usp=drive_link'
  },
];

const HackerRankCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="HackerRank"
      certificates={certificates}
    />
  );
};

export default HackerRankCertificates;
